<template>
    <div class="center">
        <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false"  v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green"/>
        <div class="row redframe">
            <div class="col s4">{{$t('customer.name_disp')}}</div>
            <div class="col s2">{{$t('customer.number')}}</div>
            <div class="col s2">{{$t('customer.status')}}</div>
            <div class="col s2"> {{$t('customer.tags')}}</div>
            <div class="col s4 input-field"><input type="text" :placeholder=customer.name v-model="customer.short_name" :disabled="editcustomers == false" v-on:click="startEdit()"/></div>
            <div class="col s2 input-field">
                <input type="text" placeholder="Numer" v-model="customer.number" :disabled="editcustomers == false" v-on:change="checkNumber"/>
            </div>
            <div class="col s2">
                <select v-model="customer.status">
                    <option value="active">{{$t('customer.active')}}</option>
                    <option value="inactive">{{$t('customer.inactive')}}</option>
                    <option value="suspended">{{$t('customer.suspended')}}</option>
                </select>
            </div>
            <div class="col s2 input-field">
                <input v-model="customer.tags" />
            </div>
        </div>
        <div class="row">
            <div class="col s1 rightlabel">{{$t('customer.name')}}</div>
            <div class="col s8 input-field">
                <input type="text" :placeholder="$t('customer.enter_fullname')" v-model="customer.name" :disabled="editcustomers == false" />
            </div>
            <div class="col s1 rightlabel">{{$t('customer.number')}}</div>
            <div class="col s2 input-field" style="text-align: left;font-size: 10px;color: rgb(194, 32, 38);">
                <input type="text" placeholder="Nadaj numer" v-model="customer.number" :disabled="editcustomers == false"  v-on:change="checkNumber"/>
                {{errors.number}}
            </div>
        </div>
        <div class="row">
            <div class="col s1 rightlabel">{{$t('customer.nip')}}</div>
            <div class="col s2"  style="text-align: left;font-size: 10px;color: rgb(194, 32, 38);">
                <div class="input-field"><input type="text" :placeholder="$t('customer.nip')" v-model="customer.nip" :disabled="editcustomers == false" /></div>
                {{errors.nip}}
            </div>
            <div class="col s1 rightlabel">{{$t('customer.krs')}}</div>
            <div class="col s2">
                <div class="input-field"><input type="text" :placeholder="$t('customer.krs')" v-model="customer.krs" :disabled="editcustomers == false" /></div>
            </div>
            <div class="col s1 rightlabel">{{$t('customer.regon')}}</div>
            <div class="col s2">
                <div class="input-field"><input type="text" :placeholder="$t('customer.regon')" v-model="customer.regon" :disabled="editcustomers == false" /></div>
            </div>
        </div>
        <div class="row">
            <div class="col s1 rightlabel">{{$t('customer.address')}}</div>
            <div class="col s3">
                <div class="input-field"><input type="text" :placeholder="$t('customer.street_placeholder')" v-model="customer.address.street" :disabled="editcustomers == false" /></div>
            </div>
            <div class="col s1 rightlabel">{{$t('customer.city')}}</div>
            <div class="col s2">
                <div class="input-field"><input type="text" :placeholder="$t('customer.city_placeholder')" v-model="customer.address.city" :disabled="editcustomers == false" /></div>
            </div>
            <div class="col s2 rightlabel">{{$t('customer.postal_code')}}</div>
            <div class="col s2 rightlabel">
                <div class="input-field"><input type="text" placeholder="00-000" v-model="customer.address.postal_code" :disabled="editcustomers == false"></div>
            </div>
            <div class="row" v-if="customer.editable">
                <div class="col s6 offset-l6 l3">
                    <a v-on:click="cancel()" class="waves-effect waves-light btn-large cancelbutton" v-if="editcustomers == true && customer.id != undefined">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s6 l3">
                    <a v-on:click="editcustomers = true" class="waves-effect waves-light btn-large" v-if="editcustomers == false">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="saveCustomer()" class="waves-effect waves-light btn-large emptygreen" v-if="editcustomers">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('customer.save') : ""}}
                    </a>
                </div>
            </div>
        </div>
        <collapsible :title="$t('customer.places')" :active="customer.id != undefined">
            <subplaces v-bind:customer_id="customer.id" v-if="customer.id != null" :role="role" :extended_privileges="extended_privileges" :status="['active', 'inactive', 'suspended']"/>
        </collapsible>
        <collapsible :title="$t('customer.contacts')" :active="customer.id != undefined">
            <template v-for="contact in getContacts">
                <div class="row" v-if="!contact.destroy">
                    <div class="col s11">
                        <div class="row" style="border-top-style: groove;border-left-style: groove;border-right-style: groove; padding-top: 1em; width: initial !important;">
                            <div class="col s6 label">
                                <autosizelabel :text="$t('customer.name_surname')" />
                                <div class="input-field">
                                    <input :disabled="!editcontacts" v-model="contact.name">
                                </div>
                            </div>
                            <div class="col s6">
                                <autosizelabel :text="$t('customer.position')" />
                                <div class="input-field">
                                    <input :disabled="!editcontacts" v-model="contact.position">
                                </div>
                            </div>
                        </div>
                        <div class="row" style="border-bottom-style: groove;border-left-style: groove;border-right-style: groove;margin-bottom: 1em !important; width: initial !important;">
                            <div class="col s3" v-bind:class="contact.errors && contact.errors.email ?  'errors' : ''">
                                <autosizelabel :text="$t('customer.email')" />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.email">
                                </div>
                                <span v-if="contact.errors && contact.errors.email">{{contact.errors.email.join(" ")}}</span>
                            </div>
                            <div class="col s3">
                                <autosizelabel :text="$t('customer.phone')" />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.phone">
                                </div>
                            </div>
                            <div class="col s3">
                                <autosizelabel :text="$t('customer.phone')" />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.phone_other">
                                </div>
                            </div>
                            <div class="col s3">
                                <label>
                                    <input :disabled="!editcontacts" type="checkbox" v-model="contact.display_on_app" checked="checked" value="true" />
                                    <span>{{$t('customer.show_mobile')}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col s1" v-if="customer.editable">
                        <modal :question="$t('customer.contact_remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="customercontactremovequestion" v-on:onConfirm="removeContact(contact)" v-if="editcontacts == true"/>
                    </div>
                </div>
            </template>
            <div class="row" v-if="customer.editable">
                <div class="col s2">
                    <a class="waves-effect waves-light btn-large solidgreen" v-on:click="addContact()">
                        {{$t('customer.add_contact')}}
                    </a>
                </div>
                <div class="col offset-s7 s2" v-if="!editcontacts && customer.contacts.length > 0">
                    <a class="waves-effect waves-light btn-large" v-on:click="editcontacts = true">
                        {{$t('menu.buttons.edit')}}
                    </a>
                </div>
                <div class="col offset-s4 s3">
                    <a class="waves-effect waves-light btn-large cancelbutton" v-on:click="cancelEditContacts()" v-if="editcontacts"> {{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s3">
                    <a class="waves-effect waves-light btn-large emptygreen" v-on:click="saveContacts()" v-if="editcontacts">{{$t('menu.buttons.save_changes')}}</a>
                </div>
            </div>
        </collapsible>
        <collapsible :title="$t('customer.customer_accounts')" :active="customer.id != undefined">
            <template v-for="user in customer.user_customers">
                <div class="row">
                    <div class="col l4 xl4 leftlabel input-field inline" style="display: flex;">
                        <autosizelabel :text="$t('customer.email')"/><input type="email" name="email" v-model="user.email" width="100%" :disabled="user.id != undefined" />
                        <p>{{user.errors ? user.errors.email : ""}}</p>
                    </div>
                    <div class="col l2 xl2 leftlabel">
                        <template v-if="user.id != undefined && user.not_accepted_invitation">
                            {{$t('customer.not_activated')}}
                        </template>
                        <template v-if="user.id != undefined && user.not_accepted_invitation == false">
                            {{$t('customer.activated')}}
                        </template>
                        {{user.error_message}}
                    </div>
                    <div class="col l3 xl3 leftlabel">
                         {{$t('customer.last_loggedin')}}: <template v-if="user.id != undefined && user.not_accepted_invitation == false">{{user.last_login | formatDate}}</template>
                        <template v-else>----</template>
                    </div>
                    <div class="col l2 xl2 leftlabel" v-if="customer.editable">
                        <a v-on:click="send_invitation(user)" class="waves-effect waves-light btn-large emptygreen" v-if="user.id == undefined && editikk == true" :disabled="user.sending == true">
                            {{$t('customer.send_invitation')}}
                        </a>
                        <a v-on:click="resend_invitation(user)" class="waves-effect waves-light btn-large emptygreen" v-if="user.id != undefined && editikk == true && user.not_accepted_invitation" :disabled="user.resending == true">
                            {{$t('customer.resend_invitation')}}
                        </a>
                        <a v-on:click="startEditIKK(user)" class="waves-effect waves-light btn-large solidgreen">{{$t('customer.privileges_button')}}</a>
                    </div>
                    <div class="col l1 xl1 leftlabel" v-if="customer.editable">
                         <modal :question="$t('customer.ikk_remove_question', {email: user.email})" :confirmText="$t('menu.buttons.delete')" identifier="removeIKKDialog" v-on:onConfirm="removeuser(user)" v-if="editikk == true"/>

                    </div>
                     
                </div>
                <div class="row" v-if="user.edit">
                        <div class="col l8 xl8 leftlabel">
                            <label>
                             <input type="checkbox" v-model="user.bases_privileges"/> 
                            <span>{{$t('customer.bases_privileges')}}</span>
                        </label>
                        </div>
                        <div class="col l4 xl4 leftlabel" v-if="user.id">
                             <a v-on:click="saveIKK(user)" class="waves-effect waves-light btn-large solidgreen"> {{$t('customer.save_customer_user')}}</a>
                        </div>
                </div>
            </template>
            <div class="row" v-if="customer.editable">
                <div class="col s2">
                    <a v-on:click="addAccount()" class="waves-effect waves-light btn-large solidgreen"> {{$t('customer.add_account')}}</a>
                </div>
                <div class="col offset-s7 s2">
                    <a v-on:click="editikk = true" class="waves-effect waves-light btn-large" v-if="editikk == false && customer.user_customers.length > 0">{{$t('menu.buttons.edit')}}</a>
                </div>
            </div>
        </collapsible>
        <collapsible :title="$t('place.documents')" :active="customer.id != undefined">
            <div class="row" v-if="customer.documents.length > 0">
                <div class="col l2 xl2 leftlabel">{{$t('documents.date_of_issue')}}</div>
                <div class="col l5 xl6 leftlabel">{{$t('documents.name')}}</div>
                <div class="col l3 xl3 leftlabel">{{$t('documents.document_type')}}</div>
            </div>
            <div class="row">
            </div>
            <div class="row" v-for="doc in  customer.documents" v-show="!doc._destroy">
                <div class="col s2 input-field">
                    <input type="date" class="datepicker" v-model="doc.date" :disabled="editdocuments == false">
                </div>
                <div class="col s6  input-field">
                    <input v-model="doc.comment" :disabled="editdocuments == false" />
                </div>
                <div class="col s2 selectorignored">
                    <select v-model="doc.doctype" :disabled="editdocuments == false">
                        <option value="pzs">{{$t('documents.types.pzs')}}</option>
                        <option value="agreement">{{$t('documents.types.agreement')}}</option>
                        <option value="agreement_annex">{{$t('documents.types.agreement_annex')}}</option>
                        <option value="instruction">{{$t('documents.types.instruction')}}</option>
                        <option value="plan">{{$t('documents.types.plan')}}</option>
                        <option value="other">{{$t('documents.types.other')}}</option>
                    </select>
                </div>
                 <div class="col s1">
                        <a :href="doc.attachment" v-if="doc.attachment"><i style="position: initial;right: initial;" class="material-icons dp48">insert_drive_file</i></a>
                        <label :for="'docfile'+index"  v-if="!doc.attachment">
                            {{ doc.file == undefined ? $t('documents.select_file') : doc.file.name }}
                        </label>
                        <input type="file" :id="'docfile'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.attachment" style="max-width: 100%;" hidden>
                    </div>
            
                <div class="col s1" v-if="customer.editable">
                    <modal :question="$t('documents.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="customerdocremovequestion" v-on:onConfirm="removeDocument(doc)" v-if="editdocuments == true"/>
                </div>
            </div>
            <div class="row">
                <div class="col l2 xl2 " style="padding-bottom: 15px;" v-if="customer.editable">
                    <a v-on:click="addDocument()" class="waves-effect waves-light btn-large solidgreen" v-if="editdocuments == true">{{$t('documents.add_document')}}</a>
                    <a v-on:click="editdocuments = true; addDocument()" class="waves-effect waves-light btn-large solidgreen" v-if="editdocuments == false">{{$t('documents.add_document')}}</a>
                </div>
                <div class="col  offset-l5 s4 l2">
                    <a v-on:click="cancelEditDocuments()" class="waves-effect waves-light btn-large cancelbutton" v-if="editdocuments == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col l2 s4">
                    <a v-on:click="editdocuments = true" class="waves-effect waves-light btn-large" v-if="editdocuments == false && customer.documents.length > 0">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="saveDocuments()" class="waves-effect waves-light btn-large emptygreen" v-if="editdocuments">
                        <div v-if="savingdocuments" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{savingdocuments == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        <collapsible :title="$t('customer.questions')" :active="customer.id != undefined">
            <div v-for="(question, index) in customer.questions" class="selectorignored"  style="padding-top: 30px; padding-bottom: 30px;">
                <div class="row" v-if="!question._destroy">
                    <div class="col s1">
                        {{$t('customer.question')}} {{index+1}}
                    </div>
                    <div class="col s8">
                        <div class="input-field">
                            <input v-model="question.text" :disabled="editquestions == false" />
                        </div>
                    </div>
                    <div class="col s2">
                        <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="editquestions == false" />
                        <label>
                            <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="editquestions == false" />
                            <span>{{$t('customer.complete_recommendation')}}</span>
                        </label>
                    </div>
                    <div class="col s1" v-if="customer.editable">
                        <a v-on:click="removeQuestion(question)" class="waves-effect waves-light btn-small red" v-if="editquestions == true">{{$t('menu.buttons.delete')}}</a>
                    </div>
                </div>
                <div class="row" v-if="question.yes_generate_recommendation && !question.destroy">
                    <div class="col offset-s1 s8" style="border: 1px solid; padding-top: 15px; padding-left: 15px;">
                        <div class="row">
                            <div class="col  s1">{{$t('inspection_procedures.description')}}</div>
                            <div class="col s11">
                                <div class="input-field"><input v-model="question.yes_recommendation_problem" :placeholder="$t('inspection_procedures.description_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t('inspection_procedures.cause')}}</div>
                            <div class="col s10">
                                <div class="input-field"><input v-model="question.yes_recommendation_cause" :placeholder="$t('inspection_procedures.cause_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t('inspection_procedures.type_procedure')}}</div>
                            <div class="col s4">
                                <select v-model="question.yes_recommendation_kind" :disabled="editquestions == false">
                                    <option value="correction">{{$t('recommendations.correction')}}</option>
                                    <option value="fixing">{{$t('recommendations.repairs')}}</option>
                                    <option value="prevention">{{$t('recommendations.prevention')}}</option>
                                    <option selected="selected" value="emergency">{{$t('recommendations.emergency')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t('inspection_procedures.solution')}}</div>
                            <div class="col s10">
                                <div class="input-field"><input v-model="question.yes_recommendation_solution" :placeholder="$t('inspection_procedures.solution_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="customer.editable">
                <div class="col s2">
                    <a class="waves-effect waves-light btn-large solidgreen" v-on:click="addQuestion()" v-if="editquestions">
                        {{$t('inspection_procedures.add_question')}}
                    </a>
                    <a class="waves-effect waves-light btn-large solidgreen" v-on:click="addQuestion()" v-if="!editquestions && customer.questions.length == 0">
                        {{$t('inspection_procedures.add_question')}}
                    </a>
                </div>
                <div class="col offset-s4 s3">
                    <a v-on:click="cancelSettingsQuestions()" class="waves-effect waves-light btn-large cancelbutton" v-if="editquestions == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s3">
                    <a v-on:click="editquestions = true" class="waves-effect waves-light btn-large" v-if="editquestions == false && customer.questions.length > 0">
                        {{$t('menu.buttons.edit')}}
                    </a>
                    <a v-on:click="saveQuestions()" class="waves-effect waves-light btn-large emptygreen" v-if="editquestions">
                        <div v-if="saving_questions" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving_questions == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        <collapsible :title="$t('customer.declarations')" :active="customer.id != undefined">
            <div class="input-field">
                <div class="row" style="text-align: left;">
                    <div class="col s2">{{$t('customer.declarations_text')}}</div>
                    <div class="col s10 input-field">
                        <editable v-model="customer.danger_clause" :placeholder="$t('customer.declarations_placeholder')" :disabled="editdangerclause == false" />
                    </div>
                </div>
            </div>
            <div class="row" style="padding-top: 15px;" v-if="customer.editable">
                <div class="col s2" v-if="!editdangerclause">
                    <a data-v-6fb8108a="" class="waves-effect waves-light btn-large" v-on:click="editdangerclause = true">{{$t('menu.buttons.edit')}}</a>
                </div>
                <div class="col s3"><a data-v-6fb8108a="" class="waves-effect waves-light btn-large cancelbutton" v-on:click="editdangerclause = false" v-if="editdangerclause"> {{$t('menu.buttons.cancel_changes')}} </a></div>
                <div class="col s3"><a data-v-6fb8108a="" class="waves-effect waves-light btn-large emptygreen" v-on:click="saveDangerClause()" v-if="editdangerclause"> {{$t('menu.buttons.save_changes')}} </a></div>
            </div>
        </collapsible>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
export default {
    props: {
        page: String,
        extended_privileges: Boolean,
        role: String
    },
    data: function() {
        return {
            editcustomers: false,
            editcontacts: false,
            editdangerclause: false,
            editdocuments: false,
            editquestions: false,
            editikk: false,
            savingikk: false,
            saving_questions: false,
            savingdocuments: false,
            saving: false,
            editsubscriptions: false,
            saving_subscriptions: false,
            errors: {number: ""},
            question: "",
            cancelText: "",
            confirmText: "",
            customer: {
                number: "",
                short_name: "",
                name: "",
                nip: "",
                krs: "",
                regon: "",
                address: {
                    street: "",
                    city: "",
                    postal_code: ""
                },
                old_customer: {},
                contacts: [],
                documents: [],
                questions: [],
                subscriptions: [],
                user_customers: [],
                editable: true
            },
            numbers: [],
            callback: null
        }
    },
    beforeRouteLeave (to, from , next) {
      if(this.editcustomers || this.editcontacts || this.editdangerclause || this.editdocuments || this.editquestions || this.editikk){
          this.question = this.$t('menu.save_question');
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.$refs.question.open();
          this.callback = next;
      }else{
        next()
      }      
    },
    mounted() {
    },
    created() {
        this.editcustomers = (this.$route.params.customer_id == 'new')
        this.old_customer = _.cloneDeep(this.customer)
        this.fetchData()
    },
    methods: {
        fetchData() {
            var that = this;
            if (this.$route.params.customer_id != 'new') {
                axios.get('/customers/' + this.$route.params.customer_id + '.json').then(response => {
                    that.customer = response.data;
                    if(_.isUndefined(that.customer.address) || _.isNull(that.customer.address)){
                        that.customer.address = {
                            street: "",
                            city: "",
                            postal_code: ""
                        }
                    }
                    for (var user_customer of this.customer.user_customers) {
                        user_customer.sending = false;
                        user_customer.resending = false;
                        user_customer.edit = false;
                    }
                    for (var contact of this.customer.contacts) {
                        contact.destroy = false;
                    }
                    that.old_customer = _.cloneDeep(response.data)
                    that.loaded = true
                    // var elems = document.querySelectorAll('.collapsible');
                    // var instances = M.Collapsible.init(elems, { accordion: false });
                })
            } else {
                var that = this;
                axios.get('/customers/numbers.json').then(response => {
                    that.numbers = response.data;
                    that.customer.number = that.getNextUniqueNumber(that.numbers);
                });
                that.loaded = true
            }
        },
        okClicked: async function(){
            if(this.editcustomers){
                await this.saveCustomer();
            }
            if(this.editcontacts){
                await this.saveContacts();
            }
            if(this.editdangerclause){
                await this.saveDangerClause();
            }
            if(this.editdocuments){
                await this.saveDocuments();
            }
            if(this.editquestions){
                await this.saveQuestions();
            }
            this.callback();
        },
        cancelClicked: function(){
            this.callback();
        },
        saveCustomer: async function() {
            if (_.isUndefined(this.customer.id)) {
                if (this.customer.number == "") {
                    this.errors.number = "Numer klienta nie może być pusty"
                } else {
                    this.errors.number = "";
                    try {
                        var cus = _.cloneDeep(this.customer);
                        cus.address_attributes = cus.address;
                        var response = await axios.post('/customers.json', { customer: cus })
                        this.editcustomers = false;
                        this.customer.id = response.data.id;
                        this.$router.push('/customers/' + this.customer.id);
                        this.errors = {};
                        this.$forceUpdate();
                    } catch (error) {
                      console.log(error.response.data);
                      for (const [key, value] of Object.entries(error.response.data.errors)) {
                        this.errors[key] = value.join(" ")
                      }
                      this.$forceUpdate();
                    }
                }
            } else {
                var cus = _.cloneDeep(this.customer);
                cus.address_attributes = cus.address;
                axios.put('/customers/' + this.customer.id + '.json', { customer: cus }).then(response => {
                    this.editcustomers = false;
                    this.old_customer = _.cloneDeep(response.data)
                    this.customer.id = response.data.id;
                })
            }
        },
        setFile: function(doc, name, file) {
          doc.file = file[0];
          this.$forceUpdate();
        },
        saveContacts: async function() {
            try {
                var response = await axios.put('/customers/' + this.customer.id + '.json', { customer: { contacts_attributes: this.customer.contacts } })
                this.editcontacts = false;
                this.customer.id = response.data.id;
                this.customer.contacts = _.cloneDeep(response.data.contacts)
            } catch (err) {
                if( err.response ){
                    this.customer.contacts = _.cloneDeep(err.response.data.contacts)
                }
            }
        },
        cancel: function() {
            this.editcustomers = false;
            this.customer = _.cloneDeep(this.old_customer)
        },
        removeContact: function(contact) {
            if (_.isUndefined(contact.id)) {
                this.customer.contacts.splice(this.customer.contacts.indexOf(contact), 1)
            } else {
                contact.destroy = true;
                const formData = new FormData();
                formData.append('customer[contacts_attributes][0][id]', contact.id);
                formData.append('customer[contacts_attributes][0][_destroy]', true);
                axios.put('/customers/' + this.$route.params.customer_id + '.json', formData).then(response => {
                    this.savingcontacts = false;
                    // this.editcontacts = false;
                    this.errors = {};
                    this.old_customer = _.cloneDeep(response.data)
                    this.customer.contacts = _.cloneDeep(response.data.contacts)
                })
                this.editcontacts = false;
                this.$forceUpdate();
            }
        },
        addContact: function() {
            if (this.editcontacts == false) this.editcontacts = true;
            this.customer.contacts.push({})
        },
        cancelEditContacts: function() {
            this.editcontacts = false;
            this.customer.contacts = _.cloneDeep(this.old_customer.contacts)
        },
        addDocument: function() {
            this.customer.documents.push({
                date: moment().format("YYYY-MM-DD"),
                doctype: "other",
                attachment: undefined
            })
        },
        removeDocument: function(doc) {           
            if (_.isUndefined(doc.id)) {
                this.customer.documents.splice(this.customer.documents.indexOf(doc), 1);
            } else {
                var docu = doc;
                this.customer.documents.splice(this.customer.documents.indexOf(doc), 1);
                this.customer.documents.push({
                    id: docu.id,
                    _destroy: true
                });
            }
        },
        startEdit: function(){
            if(_.isNil(this.customer.short_name)){
                this.customer.short_name = _.clone(this.customer.name)
            }else if(_.isEmpty(this.customer.short_name)){
                this.customer.short_name = _.clone(this.customer.name)
            }
        },
        startEditIKK: function(user) {
            user.edit = true;
            this.$forceUpdate();
        },
        cancelEditIKK: function() {
            user.edit = false;
            this.customer.user_customers = _.cloneDeep(this.old_customer.user_customers);
            this.$forceUpdate();
        },
        saveIKK: function(user) {
            this.savingikk = true;
            const formData = new FormData();
            if (user.id) formData.append('customer[user_customers_attributes][0][id]', user.id);
            if (user.bases_privileges) formData.append('customer[user_customers_attributes][0][bases_privileges]', user.bases_privileges);
            axios.put('/customers/' + this.$route.params.customer_id + '.json', formData).then(response => {
                user.edit = false;
                this.$forceUpdate();
            });
        },
        cancelEditDocuments: function() {
            this.editdocuments = false;
            this.customer.documents = _.cloneDeep(this.old_customer.documents)
        },
        saveDocuments: async function() {
            this.savingdocuments = true
            var docs = 0;
            const formData = new FormData();
            for (var doc of this.customer.documents) {
                if (doc.id) formData.append('customer[documents_attributes][' + docs + '][id]', doc.id);
                formData.append('customer[documents_attributes][' + docs + '][doctype]', doc.doctype);
                formData.append('customer[documents_attributes][' + docs + '][date]', doc.date);
                formData.append('customer[documents_attributes][' + docs + '][comment]', doc.comment);
                if (doc.file) formData.append('customer[documents_attributes][' + docs + '][attachment]', doc.file);
                if (doc.destroy) formData.append('customer[documents_attributes][' + docs + '][_destroy]', true);
                docs += 1;
            }
            try{
                var response = axios.put('/customers/' + this.$route.params.customer_id + '.json', formData);
                this.savingdocuments = false;
                this.editdocuments = false;
                this.errors = {};
                this.old_settings = _.cloneDeep(response.data)
            }catch(err){

            }
        },
        saveDangerClause: async function() {
            var response = await axios.put('/customers/' + this.customer.id + '.json', { customer: { danger_clause: this.customer.danger_clause || "" } })
            this.editdangerclause = false;
        },
        addAccount: function() {
            this.editikk = true;
            this.customer.user_customers.push({ email: "", id: undefined, error_message: undefined, sending: false })
        },
        removeuser: async function(user) {
            if (user.id != undefined) {
                const formData = new FormData();
                formData.append('customer[user_customers_attributes][0][id]', user.id);
                formData.append('customer[user_customers_attributes][0][_destroy]', true);
                await axios.put('/customers/' + this.customer.id + '.json', formData);
            }
            this.customer.user_customers.splice(this.customer.user_customers.indexOf(user), 1);
        },
        addQuestion: function() {
            this.editquestions = true
            this.customer.questions.push({ yes_recommendation_kind: 'fixing' })
        },
        send_invitation: async function(user) {
            delete user.errors
            if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email) == false){
                user.errors = {"email": "Podany adres email jest nieprawidłowy"}
                this.$forceUpdate();
                return
            }
            this.$forceUpdate();
            user.sending = true
            try {
                user.error_message = undefined;
                let req = await axios.post('/customers/' + this.customer.id + '/user.json', { email: user.email, bases_privileges: user.bases_privileges })
                user.id = req.data.id
                user.not_accepted_invitation = req.data.not_accepted_invitation
            } catch (error) {
                user.error_message = error.response.data.message;
            }
            user.sending = false
        },
        resend_invitation: async function(user) {
            this.$forceUpdate()

            user.resending = true;
            try {
                user.error_message = undefined;
                let req = await axios.post('/customers/' + this.customer.id + '/resend_invitation.json', { email: user.email })
            } catch (error) {
                user.error_message = error.response.data.message;
            }
            user.resending = false;
            this.$forceUpdate()
        },
        editAccountPrivileges: function(user){
            user.edit = true;
        },
        removeQuestion: function(question) {
            if (confirm("Czy chcesz usunąć to pytanie ?")) {
                if (_.isUndefined(question.id)) this.customer.questions.splice(this.customer.questions.indexOf(question), 1)
                else {
                    question.destroy = true
                }
            }
        },
        saveQuestions: function() {
            const formData = new FormData();
            var docs = 0;
            for (var question of this.customer.questions) {
                if (question.id) formData.append('customer[helping_questions_attributes][' + docs + '][id]', question.id);
                formData.append('customer[helping_questions_attributes][' + docs + '][text]', question.text);
                formData.append('customer[helping_questions_attributes][' + docs + '][yes_generate_recommendation]', question.yes_generate_recommendation);
                formData.append('customer[helping_questions_attributes][' + docs + '][yes_recommendation_problem]', question.yes_recommendation_problem);
                formData.append('customer[helping_questions_attributes][' + docs + '][yes_recommendation_cause]', question.yes_recommendation_cause);
                formData.append('customer[helping_questions_attributes][' + docs + '][yes_recommendation_kind]', question.yes_recommendation_kind);
                formData.append('customer[helping_questions_attributes][' + docs + '][yes_recommendation_solution]', question.yes_recommendation_solution);
                if (question.destroy) formData.append('customer[helping_questions_attributes][' + docs + '][_destroy]', true);
                docs += 1;
            }
            var response = axios.put('/customers/' + this.customer.id + '.json', formData)
            this.editquestions = false;
            
        },
        cancelSettingsQuestions: function() {
            this.editquestions = false;
            this.customer.questions = _.cloneDeep(this.old_customer.questions)
        },
        checkNumber: function(e){
            var number = e.target.value;
            if(this.numbers.indexOf(number) > -1) this.errors.number = "Podany numer klienta został wykorzystany";
            else this.errors.number = "";
        },
        getNextUniqueNumber(strings) {
            const numbers = strings.map(str => {
            const match = str.match(/\d+/);
                return match ? parseInt(match[0], 10) : null;
            }).filter(num => num !== null).sort((a, b) => a - b);

            // Find the least missing number
            let leastNumber = 1;
            for (const num of numbers) {
                if (num === leastNumber) {
                    leastNumber++;
                } else if (num > leastNumber) {
                    break;
                }
            }

            // Generate the least number, padded with zeros
            const nextNumber = leastNumber.toString().padStart(3, '0');

                return nextNumber;
        }
    },
    computed: {
        getContacts: function() {
            return _.filter(this.customer.contacts, function(contact) {
                return contact.destroy != true
            });
        },
        getDocuments: function() {
            return _.filter(this.customer.documents, function(doc) {
                return doc._destroy != true
            });
        }
    },
    mixins: [Vue2Filters.mixin],

}
</script>
<style scoped>
.redframe {
    text-align: left;
    background-color: rgb(194, 32, 38);
    margin-bottom: 20px !important;
}

.center {
    padding: 15px;
}

.input-field {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.input-field>.input-field {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.input-field>input {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}

.solidgreen {
    background-color: #00CC66;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.active>.collapsible-header {
    background-color: #C22026;
}

.collapsible li .collapsible-header>i {
    position: absolute;
    right: 4%;
    padding-right: 0px;
}

li.active>.collapsible-header>i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.nested-collapsible {
    padding-right: 0px;
    padding-bottom: 0px;
    border-bottom-width: 0px;
}

.nested-collapsible .collapsible {
    margin-right: 0px;
}

/deep/ .collapsible-header, .collapsible-header:focus{
    background-color: #bebbbb !important;
    text-transform: uppercase;
}
.active>.collapsible-header {
    background-color: #C22026;
}

.collapsible-body>.input-field {
    margin-bottom: 0rem;
    margin-top: 0rem;
}

.row .input-field {
    margin-bottom: 0rem;
    margin-top: 0rem;
}

.row {
    margin-bottom: 0rem;
}

@media only screen and (min-width: 993px) {
    .l1l5 {
        width: calc(8.3333333333% * 1.5);
        margin-left: auto;
        left: auto;
        right: auto;
    }
}

.s1s5 {
    width: calc(8.3333333333% * 1.5);
    margin-left: auto;
    left: auto;
    right: auto;
}
/deep/ .collapsible-header>i {
    position: absolute !important;
    right: 2%;
}

.label {
    text-align: left;
    line-height: 2;
}

select {
    display: block;
    padding: 0px;
    height: 35px;
}

/deep/ .collapsible-body {
    border-bottom: 0px solid #ddd;
    padding-right: 10px;
}

.col .row .col div {
    display: flex;
    max-height: 60px;
}
div[placeholder]:empty:before {
    content: attr(placeholder) !important;
    color: #DADADA !important;
}
.errors input{
    border-color: #C22026 !important;
    margin-bottom: 0px !important;
}
.errors span{
    color: #C22026;
}
</style>
